import Product from '~/models/Product/Product'
import LuigisBoxItem from '~/models/LuigisBox/LuigisBoxItem'
import OrderCartItem from '~/models/Api/Cart/OrderCartItem'
import LuigisBoxCartItem from '~/models/LuigisBox/LuigisBoxCartItem'

export const transformProductsToLuigisBoxItems = (products: Product[]): LuigisBoxItem[] => {
    const config = useRuntimeConfig()
    const luigisBoxItems: LuigisBoxItem[] = []
    for (let i = 0; i < products.length; i++) {
        const product = products[i]
        luigisBoxItems.push({
            title: product.name,
            url: `${config.public.apiUrl}${product.url}`,
            position: i + 1,
            price: product.price,
            type: 'item',
        })
    }

    return luigisBoxItems
}

export const transformCartProductsToLuigisBoxItems = (cartProducts: OrderCartItem[], products: Product[]): LuigisBoxCartItem[] => {
    const config = useRuntimeConfig()
    const luigisBoxItems: LuigisBoxCartItem[] = []
    for (let i = 0; i < cartProducts.length; i++) {
        const cartProduct = cartProducts[i]
        const product = products.find((pr: Product) => pr.id === cartProduct.id)
        if (!product) {
            continue
        }

        luigisBoxItems.push({
            title: cartProduct.name,
            url: `${config.public.apiUrl}${cartProduct.url}`,
            count: cartProduct.amount,
            total_price: cartProduct.price,
            was_discounted: product.percentDiscount !== null,
            was_volume_discounted: product.amountPrices.length === 0 ? false : cartProduct.amount >= product.amountPrices[0].from,
        })
    }

    return luigisBoxItems
}
